import { AvatarIcon, ImageIcon } from "@radix-ui/react-icons"

type IconProps = React.HTMLAttributes<SVGElement>

export const Icons = {
  logo: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={146.763}
      height={39.281}
      viewBox="0 0 38.831 10.393"
      {...props}
    >
      <path fill="#f1787f" d="M20.367 4.544H15.97V.148h4.397z" />
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={0.293}
        d="M20.367 4.544H15.97V.148h4.397z"
      />
      <path d="M16.897.816h.645L18.866 2.9V.816h.57v3.059h-.608l-1.362-2.15v2.15h-.57" />
      <path
        fill="currentColor"
        d="M8.34 1.136c-.46 0-.816.143-1.065.43-.25.282-.375.668-.375 1.155 0 .435.11.809.332 1.121.226.31.598.463 1.12.463.238 0 .453-.042.643-.128.296.22.517.35.665.39l.2-.396a1.921 1.921 0 0 1-.485-.279c.257-.316.386-.706.386-1.171 0-.487-.126-.873-.375-1.155-.247-.287-.595-.43-1.045-.43zm-8.006.112v1.634c0 .432.03.733.09.904.059.168.18.307.364.419.182.108.436.162.76.162.33 0 .582-.063.754-.19a.788.788 0 0 0 .317-.469c.042-.186.063-.466.063-.842V1.248h-.591v1.701c0 .398-.042.653-.127.765-.08.111-.225.167-.433.167a.628.628 0 0 1-.4-.117.45.45 0 0 1-.175-.296 4.207 4.207 0 0 1-.026-.557V1.248zm9.812 0v1.634c0 .432.03.733.09.904.06.168.181.307.364.419.183.108.436.162.76.162.33 0 .582-.063.755-.19a.789.789 0 0 0 .317-.469c.042-.186.063-.466.063-.842V1.248h-.592v1.701c0 .398-.042.653-.126.765-.081.111-.225.167-.433.167a.628.628 0 0 1-.401-.117.45.45 0 0 1-.174-.296 4.207 4.207 0 0 1-.027-.557V1.248zm-6.989.01v3.07h.554V2.302l1.183 2.026h.602v-3.07h-.544v2.077L3.743 1.259zm2.809 0v3.07h.601v-3.07zm7.004 0v3.07h2.248v-.474h-1.652v-.905h1.483v-.468h-1.483v-.748h1.6V1.26zm-4.634.358c.542 0 .812.368.812 1.105 0 .36-.077.637-.232.83a1.996 1.996 0 0 0-.565-.317l-.148.318c.11.04.243.117.402.229a.84.84 0 0 1-.29.061c-.278 0-.483-.11-.613-.329a1.578 1.578 0 0 1-.19-.792c0-.342.072-.612.216-.81a.71.71 0 0 1 .608-.295zM2.452 5.778c-.613 0-1.128.186-1.547.558-.42.367-.63.916-.63 1.65 0 .66.19 1.202.567 1.626.377.419.932.628 1.666.628.77 0 1.395-.222 1.877-.667V7.892h-1.91v.651H3.49v.637c-.33.251-.678.377-1.045.377-.393 0-.701-.141-.927-.424-.22-.283-.33-.676-.33-1.179 0-.995.422-1.493 1.265-1.493.53 0 .86.231.99.692l.873-.157c-.173-.812-.794-1.218-1.863-1.218zm29.008 0c-.68 0-1.207.204-1.58.613-.366.403-.55.95-.55 1.642 0 .676.19 1.213.566 1.61.378.399.904.597 1.58.597.665 0 1.183-.198 1.555-.596.372-.404.558-.946.558-1.627 0-.608-.165-1.131-.495-1.571-.325-.445-.87-.668-1.634-.668zm-26.462.087v4.32h3.347v-.667h-2.46V8.245h2.208v-.66H5.886V6.532h2.38v-.667zm3.928 0v4.32h.826V7.335l1.76 2.852h.895V5.865h-.81v2.922L9.799 5.865Zm4.204 0v4.32h3.347v-.667h-2.46V8.245h2.209v-.66h-2.209V6.532h2.381v-.667zm3.928 0v4.32h.888V8.348h.181c.241 0 .42.034.534.102a.957.957 0 0 1 .322.314l.951 1.423h1.037l-.495-.786c-.346-.555-.71-.932-1.092-1.131.849-.126 1.273-.53 1.273-1.21 0-.451-.142-.762-.424-.935-.283-.173-.718-.26-1.305-.26zm5.65 0-1.682 4.32h.927l.362-.997h1.744l.385.998h.95l-1.728-4.321zm2.836 0v.667h1.304v3.654h.888V6.532h1.296v-.667zm8.588 0v4.32h.887V8.348h.181c.241 0 .419.034.534.102a.958.958 0 0 1 .322.314l.951 1.423h1.037L37.55 9.4c-.346-.555-.71-.932-1.092-1.131.849-.126 1.273-.53 1.273-1.21 0-.451-.141-.762-.424-.935-.283-.173-.718-.26-1.305-.26zm-2.664.596c.807 0 1.21.508 1.21 1.525 0 .455-.102.833-.307 1.131-.204.294-.505.44-.903.44-.382 0-.684-.139-.904-.416-.214-.283-.322-.66-.322-1.132 0-1.031.409-1.548 1.226-1.548zm-13.522.071h.692c.471 0 .772.04.903.118.136.073.205.23.205.472 0 .251-.082.416-.244.494-.157.074-.456.11-.896.11h-.66zm17.073 0h.692c.471 0 .772.04.903.118.136.073.205.23.205.472 0 .251-.082.416-.244.494-.157.074-.456.11-.896.11h-.66zm-11.84.306.62 1.69h-1.24z"
        style={{
          fontSize: "8.8312px",
          lineHeight: 1.25,
          fontFamily: "Gidugu",
          strokeWidth: 0.22078,
        }}
      />
      <path fill="#f1787f" d="M20.367 4.544H15.97V.148h4.397z" />
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={0.293}
        d="M20.367 4.544H15.97V.148h4.397z"
      />
      <path d="M16.897.816h.645L18.866 2.9V.816h.57v3.059h-.608l-1.362-2.15v2.15h-.57" />
      <path fill="#89ceeb" d="M20.566 5.179h4.396V.782h-4.396z" />
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={0.293}
        d="M24.966 5.179h-4.397V.782h4.397z"
      />
      <path d="M23.516 2.975c0-.42-.31-.754-.734-.754a.738.738 0 0 0-.741.754c0 .427.322.762.741.762.424 0 .734-.339.734-.762m-2.033.008c0-.812.595-1.278 1.216-1.278.322 0 .607.13.787.344v-.293h.566v2.45h-.566v-.318c-.18.23-.473.37-.796.37-.59 0-1.207-.47-1.207-1.275" />
      <path
        fill="#fbd87c"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={0.293}
        d="M24.91 4.597h4.397V.201h-4.396z"
      />
      <path d="M25.64 1.486h.427v.217a.648.648 0 0 1 .532-.255c.293 0 .494.118.605.322a.715.715 0 0 1 .612-.322c.506 0 .757.293.757.78V3.35h-.439V2.263c0-.27-.137-.442-.404-.442-.233 0-.411.159-.411.487v1.041h-.436V2.251c0-.268-.134-.43-.392-.43-.242 0-.42.165-.42.496V3.35h-.43" />
      <path fill="#a8d463" d="M29.359 5.311h4.396V.915H29.36z" />
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={0.293}
        d="M33.759 5.311h-4.397V.915h4.397z"
      />
      <path d="M30.859 2.838h1.39c-.083-.33-.335-.503-.686-.503a.72.72 0 0 0-.704.503m-.57.281c0-.716.557-1.282 1.274-1.282.729 0 1.26.536 1.26 1.261v.214H30.83c.08.348.352.578.754.578a.714.714 0 0 0 .68-.432l.464.269c-.213.398-.59.662-1.144.662-.77 0-1.294-.562-1.294-1.27" />
    </svg>
  ),
  nextjs: (props: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M11.572 0c-.176 0-.31.001-.358.007a19.76 19.76 0 0 1-.364.033C7.443.346 4.25 2.185 2.228 5.012a11.875 11.875 0 0 0-2.119 5.243c-.096.659-.108.854-.108 1.747s.012 1.089.108 1.748c.652 4.506 3.86 8.292 8.209 9.695.779.25 1.6.422 2.534.525.363.04 1.935.04 2.299 0 1.611-.178 2.977-.577 4.323-1.264.207-.106.247-.134.219-.158-.02-.013-.9-1.193-1.955-2.62l-1.919-2.592-2.404-3.558a338.739 338.739 0 0 0-2.422-3.556c-.009-.002-.018 1.579-.023 3.51-.007 3.38-.01 3.515-.052 3.595a.426.426 0 0 1-.206.214c-.075.037-.14.044-.495.044H7.81l-.108-.068a.438.438 0 0 1-.157-.171l-.05-.106.006-4.703.007-4.705.072-.092a.645.645 0 0 1 .174-.143c.096-.047.134-.051.54-.051.478 0 .558.018.682.154.035.038 1.337 1.999 2.895 4.361a10760.433 10760.433 0 0 0 4.735 7.17l1.9 2.879.096-.063a12.317 12.317 0 0 0 2.466-2.163 11.944 11.944 0 0 0 2.824-6.134c.096-.66.108-.854.108-1.748 0-.893-.012-1.088-.108-1.747-.652-4.506-3.859-8.292-8.208-9.695a12.597 12.597 0 0 0-2.499-.523A33.119 33.119 0 0 0 11.573 0zm4.069 7.217c.347 0 .408.005.486.047a.473.473 0 0 1 .237.277c.018.06.023 1.365.018 4.304l-.006 4.218-.744-1.14-.746-1.14v-3.066c0-1.982.01-3.097.023-3.15a.478.478 0 0 1 .233-.296c.096-.05.13-.054.5-.054z"
      />
    </svg>
  ),
  gitHub: (props: IconProps) => (
    <svg viewBox="0 0 438.549 438.549" {...props}>
      <path
        fill="currentColor"
        d="M409.132 114.573c-19.608-33.596-46.205-60.194-79.798-79.8-33.598-19.607-70.277-29.408-110.063-29.408-39.781 0-76.472 9.804-110.063 29.408-33.596 19.605-60.192 46.204-79.8 79.8C9.803 148.168 0 184.854 0 224.63c0 47.78 13.94 90.745 41.827 128.906 27.884 38.164 63.906 64.572 108.063 79.227 5.14.954 8.945.283 11.419-1.996 2.475-2.282 3.711-5.14 3.711-8.562 0-.571-.049-5.708-.144-15.417a2549.81 2549.81 0 01-.144-25.406l-6.567 1.136c-4.187.767-9.469 1.092-15.846 1-6.374-.089-12.991-.757-19.842-1.999-6.854-1.231-13.229-4.086-19.13-8.559-5.898-4.473-10.085-10.328-12.56-17.556l-2.855-6.57c-1.903-4.374-4.899-9.233-8.992-14.559-4.093-5.331-8.232-8.945-12.419-10.848l-1.999-1.431c-1.332-.951-2.568-2.098-3.711-3.429-1.142-1.331-1.997-2.663-2.568-3.997-.572-1.335-.098-2.43 1.427-3.289 1.525-.859 4.281-1.276 8.28-1.276l5.708.853c3.807.763 8.516 3.042 14.133 6.851 5.614 3.806 10.229 8.754 13.846 14.842 4.38 7.806 9.657 13.754 15.846 17.847 6.184 4.093 12.419 6.136 18.699 6.136 6.28 0 11.704-.476 16.274-1.423 4.565-.952 8.848-2.383 12.847-4.285 1.713-12.758 6.377-22.559 13.988-29.41-10.848-1.14-20.601-2.857-29.264-5.14-8.658-2.286-17.605-5.996-26.835-11.14-9.235-5.137-16.896-11.516-22.985-19.126-6.09-7.614-11.088-17.61-14.987-29.979-3.901-12.374-5.852-26.648-5.852-42.826 0-23.035 7.52-42.637 22.557-58.817-7.044-17.318-6.379-36.732 1.997-58.24 5.52-1.715 13.706-.428 24.554 3.853 10.85 4.283 18.794 7.952 23.84 10.994 5.046 3.041 9.089 5.618 12.135 7.708 17.705-4.947 35.976-7.421 54.818-7.421s37.117 2.474 54.823 7.421l10.849-6.849c7.419-4.57 16.18-8.758 26.262-12.565 10.088-3.805 17.802-4.853 23.134-3.138 8.562 21.509 9.325 40.922 2.279 58.24 15.036 16.18 22.559 35.787 22.559 58.817 0 16.178-1.958 30.497-5.853 42.966-3.9 12.471-8.941 22.457-15.125 29.979-6.191 7.521-13.901 13.85-23.131 18.986-9.232 5.14-18.182 8.85-26.84 11.136-8.662 2.286-18.415 4.004-29.263 5.146 9.894 8.562 14.842 22.077 14.842 40.539v60.237c0 3.422 1.19 6.279 3.572 8.562 2.379 2.279 6.136 2.95 11.276 1.995 44.163-14.653 80.185-41.062 108.068-79.226 27.88-38.161 41.825-81.126 41.825-128.906-.01-39.771-9.818-76.454-29.414-110.049z"
      ></path>
    </svg>
  ),
  google: ({ ...props }: IconProps) => (
    <svg role="img" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z"
      />
    </svg>
  ),
  twitter: (props: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M21.543 7.104c.015.211.015.423.015.636 0 6.507-4.954 14.01-14.01 14.01v-.003A13.94 13.94 0 0 1 0 19.539a9.88 9.88 0 0 0 7.287-2.041 4.93 4.93 0 0 1-4.6-3.42 4.916 4.916 0 0 0 2.223-.084A4.926 4.926 0 0 1 .96 9.167v-.062a4.887 4.887 0 0 0 2.235.616A4.928 4.928 0 0 1 1.67 3.148a13.98 13.98 0 0 0 10.15 5.144 4.929 4.929 0 0 1 8.39-4.49 9.868 9.868 0 0 0 3.128-1.196 4.941 4.941 0 0 1-2.165 2.724A9.828 9.828 0 0 0 24 4.555a10.019 10.019 0 0 1-2.457 2.549z"
      />
    </svg>
  ),
  facebook: ({ ...props }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" {...props}>
      <path
        fill="currentColor"
        d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
      />
    </svg>
  ),
  discord: ({ ...props }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" {...props}>
      <path
        fill="currentColor"
        d="M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"
      />
    </svg>
  ),
  spinner: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
  ),
  cart: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="8" cy="21" r="1" />
      <circle cx="19" cy="21" r="1" />
      <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
    </svg>
  ),
  product: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
      <path d="M3 6h18" />
      <path d="M16 10a4 4 0 0 1-8 0" />
    </svg>
  ),
  store: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7" />
      <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
      <path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4" />
      <path d="M2 7h20" />
      <path d="M22 7v3a2 2 0 0 1-2 2v0a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12v0a2 2 0 0 1-2-2V7" />
    </svg>
  ),
  credit: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect width="20" height="14" x="2" y="5" rx="2" />
      <line x1="2" x2="22" y1="10" y2="10" />
    </svg>
  ),
  dollarSign: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <line x1="12" x2="12" y1="2" y2="22" />
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
    </svg>
  ),
  bot: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12 8V4H8" />
      <rect width="16" height="12" x="4" y="8" rx="2" />
      <path d="M2 14h2" />
      <path d="M20 14h2" />
      <path d="M15 13v2" />
      <path d="M9 13v2" />
    </svg>
  ),
  shirt: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z" />
    </svg>
  ),
  footprints: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z" />
      <path d="M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z" />
      <path d="M16 17h4" />
      <path d="M4 13h4" />
    </svg>
  ),
  robot: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect width="18" height="10" x="3" y="11" rx="2" />
      <circle cx="12" cy="5" r="2" />
      <path d="M12 7v4" />
      <line x1="8" x2="8" y1="16" y2="16" />
      <line x1="16" x2="16" y1="16" y2="16" />
    </svg>
  ),
  avatar: AvatarIcon,
  placeholder: ImageIcon,
}
